import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Constants } from "../../shared/Constants";
import { Observable } from "rxjs";

@Injectable()
export class CampaignTypeService {
  constructor(private http: HttpClient) {}

  getAllByClient(clientId: number): Observable<any[]> {
    let headers = new HttpHeaders();
    headers = headers.set("Content-type", "application/json");
    headers = headers.set(
      "Authorization",
      "Basic " + btoa(localStorage.getItem("jwt"))
    );
    return this.http.get<any[]>(
      Constants.URL_BACKEND + "/campaign-type/client/" + clientId,
      { headers: headers }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/campaign-type.service.ts